import selectSettings from './selectSettings';

const selectUserSettings = (state, integration) => selectSettings(state).user;

export default selectUserSettings;
